import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69c3d0267d947e0014f70f19_1789326469003_174bf2ab/perfmanage/src/components/SWRProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_production/69c3d0267d947e0014f70f19_1789326469003_174bf2ab/perfmanage/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69c3d0267d947e0014f70f19_1789326469003_174bf2ab/perfmanage/src/styles/tailwind.css");
